<app-loader
  [apiCall]="this.apiCall"
  [loader]="true"
  [loaderId]="'accountMoveCreateModal'"
  style="min-height: 150px"
>
  <form
    [formGroup]="paymentForm"
    (ngSubmit)="onSubmit()"
    [hasUnsavedData]="paymentForm"
  >
    <button type="submit" hidden="hidden"></button>

    <div class="row mb-2">
      <div class="col-12 mr-auto"></div>
    </div>

    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >CONTRACT_LBL_ACCOUNT_MOVE_TYPE</label
          >

          <div class="col">
            @if (!!this.insuranceClaimId) {
              <!-- On a claim, the type is forced to "Frais de sinistre": show it read-only. -->
              <app-typeahead
                [limitToList]="true"
                [dataType]="DataType.Enum"
                [referenceEndpoint]="'Views/enum/values'"
                [referenceField]="
                'Comparanoo.Core.Enums.Accounting.InsuranceClaimAccountMoveCategory'
              "
                [valueMember]="'name'"
                [displayMember]="'name'"
                [dropdownStyle]="DropdownStyle.DropDownList"
                [controlForm]="this.paymentForm.get('accountMoveName')"
                [showFirstElement]="true"
                [readonly]="true"
              />
            } @else {
              <app-typeahead
                [limitToList]="true"
                [dataType]="DataType.Enum"
                [referenceEndpoint]="'Views/enum/values'"
                [referenceField]="
                'Comparanoo.Core.Enums.Accounting.ContractAccountMoveCategory'
              "
                [valueMember]="'name'"
                [displayMember]="'name'"
                [dropdownStyle]="DropdownStyle.DropDownList"
                [controlForm]="this.paymentForm.get('accountMoveName')"
                [readonly]="this.isEdit"
              />
            }

          </div>
        </div>

        @if (isClient) {
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >PAYMENT_LBL_TO</label
            >
            <div class="col">
              <app-typeahead
                [routeEndpoint]="'Accounts'"
                [controlForm]="this.paymentForm.get('creditAccountId')"
                [domain]="this.accountToDomain"
                [orderBy]="'name asc'"
                [limitToList]="true"
                [readonly]="this.isEdit"
              />
            </div>
          </div>
        }
        @if (!isClient) {
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >PAYMENT_LBL_FROM</label
            >
            <div class="col">
              <app-typeahead
                [routeEndpoint]="'Accounts'"
                [controlForm]="this.paymentForm.get('debitAccountId')"
                [domain]="'accountType=2,active=1'"
                [orderBy]="'name asc'"
                [limitToList]="true"
                [readonly]="this.isEdit"
              />
            </div>
          </div>
        }

        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >CONTRACT_LBL_ACCOUNT_MOVE_NAME</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              type="text"
              formControlName="accountMoveLineName"
              checkFormFieldValidity
              [readonly]="this.isEdit"
            />
          </div>
        </div>

        @if (this.isRecurringFees) {
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >CONTRACT_LBL_ACCOUNTMOVE_PERIOD</label
            >
            <div class="col">
              <app-typeahead
                [controlForm]="this.paymentForm.controls['accountMovePeriod']"
                [dataValueMember]="'name'"
                [dropdownStyle]="DropdownStyle.DropDownList"
                [limitToList]="true"
                [data]="this.accountMovePeriodsModels$ | async"
                [readonly]="this.isEdit"
              />
            </div>
          </div>
        }
      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >PAYMENT_LBL_AMOUNT
          </label>
          <div class="col">
            <input
              class="form-control form-control-sm"
              type="text"
              formControlName="unitPrice"
              checkFormFieldValidity
              [placeholder]="this.unitPricePlaceholder | translate"
              mask="separator.2"
              [suffix]="this.unitPriceSuffix | translate"
              [showMaskTyped]="false"
              [decimalMarker]="'.'"
              [allowNegativeNumbers]="false"
            />
          </div>
        </div>

        @if (this.isRecurringFees) {
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >CONTRACT_LBL_ACCOUNTMOVE_PERIOD_START_DATE</label
            >
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="date"
                [max]="this.maxDateMaskSafeGuard"
                formControlName="periodStartDate"
                checkFormFieldValidity
                [readonly]="this.isEdit"
              />
            </div>
          </div>
        }

        @if (this.isRecurringFees) {
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >CONTRACT_LBL_ACCOUNTMOVE_PERIOD_END_DATE</label
            >
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="date"
                [max]="this.maxDateMaskSafeGuard"
                formControlName="periodEndDate"
                checkFormFieldValidity
                [readonly]="this.isEdit"
              />
            </div>
          </div>
        }
      </div>
    </div>
  </form>
</app-loader>
